module.exports = __webpack_public_path__ + "static/media/home-de.6c022010.jpeg";